

.icon{
  position: relative;
  display: inline-block;


  &:hover .info,
  .info.forceDisplay {
    visibility: visible;
  }
  .info
  {
    pointer-events: none;
    position: absolute;
    visibility: hidden;
    bottom: 15px;
    left: 15px;
    line-height: 1rem;
    color: black;
    font-size: 0.9em;
    font-family: var(--font-family-body), serif;
    font-weight: 400;
    border: 1px solid var(--beigedarker);
    border-radius: 7px;
    padding: 1em;
    background: white;
    max-width: 280px;
    width: max-content;
    cursor: pointer;

    z-index: 1000;

    box-shadow: 5px 5px 8px 0 rgba(0, 0, 0, 0.1);

    &.infoRight {
      left: auto;
      right: 15px;
    }
    &.infoBottom {
      bottom: auto;
      top: 15px;
    }
  }
}
